import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { DentoProvider } from './context/DentoContext';
import "./App.css";
import { HospitalNavbar } from "./components/HospitalNavbar";
import { DentoFooter } from "./components/ui/footer-section";
import { AppointmentModal } from "./components/AppointmentModal";
import { HomePage } from "./pages/HomePage";
import { AdminDashboard } from "./pages/AdminDashboard";
import { SeedDataPage } from "./pages/SeedDataPage";

function AppContent() {
  const [isAppointmentModalOpen, setIsAppointmentModalOpen] = useState(false);
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin') || location.pathname.startsWith('/seed');

  return (
    <div className="App flex flex-col min-h-screen">
      {!isAdmin && (
        <HospitalNavbar
          onAppointmentClick={() => setIsAppointmentModalOpen(true)}
        />
      )}

      <main className={`flex-grow ${!isAdmin ? 'pt-20 lg:pt-32' : ''}`}>
        <Routes>
          <Route
            path="/"
            element={
              <HomePage
                onAppointmentClick={() => setIsAppointmentModalOpen(true)}
              />
            }
          />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/seed" element={<SeedDataPage />} />
        </Routes>
      </main>

      {!isAdmin && <DentoFooter />}

      <AppointmentModal
        isOpen={isAppointmentModalOpen}
        onClose={() => setIsAppointmentModalOpen(false)}
      />
    </div>
  );
}

function App() {
  return (
    <DentoProvider>
      <Router>
        <AppContent />
      </Router>
    </DentoProvider>
  );
}

export default App;